module.exports = __webpack_public_path__ + "img/we_logo.c4f96eb4.png";